window.addEventListener('load', () => {
  const pwp = document.querySelector('ample-pwp');
  if (!pwp || !pwp.shadowRoot) return;
  console.log('Adopting PWP styles into shadow DOM');
  const styleEl = document.getElementById('pwp-styles');
  if (!styleEl?.sheet) return;


  let cssText = '';
  for (const rule of styleEl.sheet.cssRules) {
    cssText += rule.cssText;
  }

  const sheet = new CSSStyleSheet();
  sheet.replaceSync(cssText);

  pwp.shadowRoot.adoptedStyleSheets =
    [...pwp.shadowRoot.adoptedStyleSheets, sheet];
console.log('PWP styles applied to shadow DOM');
});